import styled from '@emotion/styled';
import { Flex } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import LanguageDropdown from 'components/common/auth/LanguageDropdown';
import ImpersonateUserModal from 'components/common/ImpersonateUserModal';
import colors from 'config/theme/colors';
import { showHealthBanner } from 'modules/app/selectors';
import { haveNotificationAccess } from 'modules/notifications/selectors/ui/configuration';
import { isImpersonateModalOpen } from 'modules/users/selectors';
import { getCurrentUsername, } from 'modules/users/selectors/currentUser';

import AppTitle from './AppTitle';
import Campus from './Campus';
import * as styles from './Header.module.less';
import HealthBanner from './HealthBanner';
import Help from './Help';
import LoginButton from '../../../common/auth/LoginButton';
import ConfigurationButton from '../../menus/ConfigurationButton';
import NotificationsButton from '../../menus/NotificationsButton';

const Header = styled(Flex)`
  color: #fff;
  background-color: ${colors['@primary-color-dark']};
`;

const FBHeader = () => {
  const open = useSelector(isImpersonateModalOpen);
  const userName = useSelector(getCurrentUsername);
  const haveNotification = useSelector(haveNotificationAccess);
  const shouldShowHealthBanner = useSelector(showHealthBanner);

  return (
    <Flex vertical className={styles.header} data-cy="header_bar" id="header" component="header">
      <Header align="center">
        <AppTitle />
        <div className={styles['header-navigation']}>
          <nav className={styles['header-usernav']}>
            <ul className={styles['header-usernav__list']}>
              {userName && (
                <React.Fragment>
                  {haveNotification && (
                    <li className={styles['header-usernav__item']}>
                      <NotificationsButton />
                    </li>
                  )}
                  <li className={styles['header-usernav__item']}>
                    <ConfigurationButton />
                  </li>
                  <li className={styles['header-usernav__item']}>
                    <LoginButton />
                  </li>
                  <li className={`${styles['header-usernav__item']} ${styles['header-usernav__item--campus']}`}>
                    <Campus />
                  </li>
                </React.Fragment>
              )}

              <li className={`${styles['header-usernav__item']} ${styles['header-usernav__item--help']}`}>
                <Help />
              </li>
              <li className={styles['header-usernav__item']}>
                <LanguageDropdown />
              </li>
            </ul>
          </nav>
        </div>
      </Header>
      {shouldShowHealthBanner && <HealthBanner />}
      {open && <ImpersonateUserModal />}
    </Flex>
  );
};

export default FBHeader;
